import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";

//typeing 애니메이션
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";

function SubHead({ title = "회사소개", eng = "COMPANY" }) {
    // const [nowClass, setNowClass] = useState(true);

    // function getLinkStyle({isActive}) {
    //     return{
    //         textDecoration: isActive? 'underline' : undefined,
    //     }
    // }

    useEffect(() => {
        Splitting();
    }, []);

    return (
        <article className="sub-header">
            <ul className="navigation">
                <li className="home">홈</li>
                <li>회사소개</li>
                <li>{title}</li>
            </ul>

            <section className="sub-header-nav">
                <div className="names">
                    <h2>COMPANY</h2>
                    <h3>회사소개</h3>
                </div>

                <nav>
                    <ul className="snb">
                        {/* 클래스 on 추가 시 색 변경 */}
                        <li>
                            <NavLink to="/company/ceo" className={({ isActive }) => (isActive ? "on" : "")}>
                                CEO 인사말
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/company/vision" className={({ isActive }) => (isActive ? "on" : "")}>
                                비전
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/company/history" className={({ isActive }) => (isActive ? "on" : "")}>
                                연혁
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/company/organization" className={({ isActive }) => (isActive ? "on" : "")}>
                                권역도
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/company/direction" className={({ isActive }) => (isActive ? "on" : "")}>
                                오시는 길
                            </NavLink>
                        </li>
                    </ul>
                </nav>
            </section>

            <section className="sub-header-visual">
                <div className="inner company">
                    <h2>{eng}</h2>
                    <h3 data-splitting="chars">{title}</h3>
                    <p>
                        앞선 기술과 품질로 최고의 네트워크 서비스를 제공합니다. <br />
                        Global NO.1 Network Service Company
                    </p>
                </div>
            </section>
        </article>
    );
}

export default SubHead;
